module.exports = __webpack_public_path__ + "static/media/notes.89266e5a.svg";